import {FC} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import {useHasModule} from '../../../auth'

const PORTAL_TICKETS_MODULE = 'tickets-do-portal-do-cliente'

const UPGRADE_TOOLTIP =
  'Este recurso está disponível apenas em planos superiores. Atualize seu plano para acessá-lo.'

type Props = {
  onShare: () => void
}

export const ProjectShareMenuItem: FC<Props> = ({onShare}) => {
  const navigate = useNavigate()
  const hasPortalModule = useHasModule(PORTAL_TICKETS_MODULE)

  if (hasPortalModule) {
    return (
      <div className='menu-item px-3'>
        <a className='menu-link px-3' onClick={onShare}>
          Compartilhar projeto
        </a>
      </div>
    )
  }

  return (
    <div className='menu-item px-3'>
      <OverlayTrigger
        placement='top'
        delay={{show: 50, hide: 100}}
        overlay={<Tooltip>{UPGRADE_TOOLTIP}</Tooltip>}
      >
        <div
          className='menu-link px-3 disabled d-flex align-items-center w-100'
          style={{cursor: 'pointer'}}
          role='button'
          tabIndex={0}
          onClick={() => navigate('/billings')}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault()
              navigate('/billings')
            }
          }}
        >
          <span>Compartilhar projeto</span>
          <i className='fa fa-lock ms-auto flex-shrink-0'></i>
        </div>
      </OverlayTrigger>
    </div>
  )
}
